<template>
    <div class="task-details-header-container" v-loading="taskInfoLoading">
        <div class="cover">
            <img :src="url || `${IMG_HOST}default.png`" alt="">
        </div>
        <div class="header-right-container">
            <div>
                <p class="title">{{name}}</p>
                <p class="reward"><span>{{ $t('comb.anchorPay') }}</span>
                    <span style="margin: 0;" v-if="prePay">{{ prePay.direct.multiplier}}{{ prePay.unit }}</span>
                    <span style="margin:0 5px;" v-if="royaltyShareRatio&&prePay&&prePay.direct.multiplier">+</span>
                    <span v-if="royaltyShareRatio">{{royaltyShareRatio?royaltyShareRatio:0}}%{{ $t('word.sharePay') }}</span>
                </p>
                <p class="require-item info"><span>{{ $t('comb.taskInfo') }}</span><span>{{categoryLabel}}</span></p>
                <p class="require-item require">
                    <span>{{ $t('comb.taskRequirement') }}</span>
                    <span>{{demandDeliveryFrequency}}</span>
                    <span v-if="demandTotalChapter">({{ $t('word.total') }}{{ demandTotalChapter }}{{ $t('word.episode') }})</span>
                    <span v-if="demandWorkSize">({{demandWorkSize}}{{ $t('word.minute') }})</span> <span>{{way}}
                </span>
                </p>
                <p class="require-item num"><span>{{ $t('comb.recruitmentAmount') }}</span><span>{{userCount}} {{ $t('word.people') }}</span></p>
                <p class="require-item track"><span>{{ $t('comb.releaseMode') }}</span><span>{{releaseWay}}</span></p>
            </div>
            <div>
                <el-button v-if="allowOperate&&viewStatusId!==4" @click="taskEnd()">{{ $t('comb.taskFinished') }}</el-button>
                <el-button v-if="allowOperate&&recruitmentType===2&&(viewStatusId==1||viewStatusId==2)" @click="dialogVisible = true">{{ $t('comb.prolongPeriodOfAddition') }}</el-button>
                <el-dialog :title="multiProlongPeriodOfAddition" v-model="dialogVisible" size="tiny">
                    <el-input v-model="days" size="small">
                        <template slot="prepend">{{ $t('comb.prolongPeriodOfAddition') }}</template>
                        <template slot="append"> {{ $t('word.day') }}</template>
                    </el-input>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">{{ $t('word.cancel') }}</el-button>
                        <el-button type="primary" @click="extendTime">{{ $t('word.ok') }}</el-button>
                    </span>
                </el-dialog>
                <div class="task-end" v-if="viewStatusId==4"></div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                taskInfoLoading: true,
                url: '',
                name: '',
                categoryLabel: '',
                royaltyShareRatio: '',
                prePay: {
                  direct: {},
                  inverse: {}
                },
                demandDeliveryFrequency: '',
                userCount: '',
                releaseWay: '',
                recruitmentType: 2,
                demandWorkSize: '',
                demandTotalChapter: 0,
                way: '',
                taskStatusId: 0,
                viewStatusId: -1,
                status: false,
                dialogVisible: false,
                allowOperate: false,
                days:''
            };
        },
        mounted() {
            this.getDetails();
        },
        methods: {
            emitToParent(requirement) {
                this.$emit('passRequirement', requirement);
            },
            emitTaskId(taskId) {
                this.$emit('passTaskId', taskId);
            },
            emitRecruitType(recruitmentOptionId) {
                this.recruitmentType = recruitmentOptionId;
                this.$emit('passRecruitType', recruitmentOptionId);
            },
            extendTime() {
                let $this = this,
                    id = $this.$route.params.id,
                    days = $this.days,
                    reg = /^[0-9]+$/,
                    isPositive = reg.test(days);
                this.dialogVisible = false;
                if(isPositive){
                    axios.post(`/api/manager/requirement/${id}/recruitment/extension/${days}`)
                        .then(function (res) {
                            if (res.data.code == 200) {
                                $this.$message({
                                    message: this.$i18n.t('sen.successfullyToProlongPeriodOfAddition')+days+this.$i18n.t('word.day'),
                                    type: 'success'
                                });
                            } else {
                                $this.$message({
                                    message: this.$i18n.t('sen.failedToProlongPeriodOfAddition'),
                                    type: 'warning'
                                });
                            }
                        })
                        .catch(function(){
                            $this.$message({
                                message: this.$i18n.t('word.error'),
                                type: 'warning'
                            });
                        });
                }else{
                    $this.$message({
                        message: this.$i18n.t('sen.dayAmountShouldBeInteger'),
                        type: 'warning'
                    });
                }
            },
            getDetails() {
                const id = this.$route.params.id;
                axios.get(`/api/manager/requirement/${id}/info`).then(res => {
                    if (res.data.code == 200) {
                        const result = res.data.data;
                        this.url = `${this.$store.state.UPLOAD_IMG_HOST}${result.coverPath}`;
                        this.name = result.name;
                        this.emitRecruitType(result.recruitmentOptionId);
                        this.categoryLabel = result.categoryLabel;
                        this.royaltyShareRatio = result.royaltyShareRatio;
                        this.demandDeliveryFrequency = result.demandDeliveryFrequency;
                        this.userCount = result.userCount;
                        this.allowOperate = result.allowOperate;
                        this.prePay = result.prePay;
                        this.$emit('allowOperate', result.allowOperate);
                        if (result.viewStatusId) {
                            this.viewStatusId = result.viewStatusId;
                            this.$emit('viewStatusId', result.viewStatusId);
                        }
                        if (result.taskEvaluation) {
                            this.$emit('taskEvaluation', result.taskEvaluation);
                        } else {
                            this.$emit('taskEvaluation', null);
                        }
                        this.releaseWay = result.demandDistributionOptionLabel;
                        this.demandWorkSize = result.demandWorkSize;
                        this.demandTotalChapter = result.demandTotalChapter;
                        this.way = result.demandStudioTypeId === 1? '': result.demandStudioTypeLabel;
                        if (result.taskStatusId) {
                            this.taskStatusId = result.taskStatusId;
                            this.$emit('taskStatusId', result.taskStatusId);
                        }
                        if (result.sampleRequirement) {
                            this.emitToParent(result.sampleRequirement);
                        }
                        if (result.taskId) {
                            this.emitTaskId(result.taskId);
                        } else {
                            this.status = true;
                        }
                        this.taskInfoLoading = false;
                    }
                }).catch(error => {
                    this.$message({
                        type: 'error',
                        message: error.message
                    });
                });
            },
            taskEnd() {
                this.$confirm(this.$i18n.t('sen.finishTaskConfirm'), this.$i18n.t('comb.warmTips'), {
                    lockScroll: false,
                    confirmButtonText: this.$i18n.t('word.ok'),
                    cancelButtonText: this.$i18n.t('word.cancel'),
                    type: 'warning',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            const id = this.$route.params.id;
                            axios.post(`/api/manager/requirement/${id}/complete`).then(result => {
                                if (result.data.code == 200) {
                                    done();
                                    setTimeout(() => {
                                        instance.confirmButtonLoading = false;
                                    }, 300);
                                    this.$message({
                                        type: 'success',
                                        message: this.$i18n.t('comb.operationSuccess')
                                    });
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 300);
                                } else {
                                    done();
                                    setTimeout(() => {
                                        instance.confirmButtonLoading = false;
                                    }, 300);
                                    this.$message({
                                        type: 'warning',
                                        message: result.data.message
                                    });
                                }
                            }).catch(error => {
                                this.$message({
                                    type: 'error',
                                    message: error.message
                                });
                            });
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                }).catch(() => {
                });
            }
        },
        computed: {
            IMG_HOST() {
                return this.$store.state.IMG_HOST;
            },
            multiProlongPeriodOfAddition() {
                return this.$i18n.t('comb.prolongPeriodOfAddition');
            }
        }
    }
</script>
<style lang="sass">
    @import "../../../sass/copyright/center/task-details-header.scss";
</style>



// WEBPACK FOOTER //
// TaskDetailsHeader.vue?5ce37814